import { generateId } from '@freelancer/datastore/testing/helpers';
import type { VerificationCorporateKyc } from './verification-corporate-kyc.model';

export interface GenerateVerificationCorporateKycOptions {
  readonly id?: number;
  readonly userId?: number;
  readonly status?: string;
  readonly createdAt?: number;
}

export function generateVerificationCorporateKycObject({
  id = generateId(),
  userId = generateId(),
  status = 'KYC Approve',
  createdAt = Date.now(),
}: GenerateVerificationCorporateKycOptions = {}): VerificationCorporateKyc {
  return {
    id,
    userId,
    status,
    createdAt,
  };
}
